import { render, staticRenderFns } from "./MarketingFormSendersExternal.vue?vue&type=template&id=db852a7c&scoped=true"
import script from "./MarketingFormSendersExternal.vue?vue&type=script&lang=js"
export * from "./MarketingFormSendersExternal.vue?vue&type=script&lang=js"
import style0 from "./MarketingFormSendersExternal.vue?vue&type=style&index=0&id=db852a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db852a7c",
  null
  
)

export default component.exports